export default {
	HADE: 'hade',
	KILITE: 'kilite',
	SELESTE: 'seleste',
	ARBAETE: 'arbaete',
	HAMUSHTE: 'hamushte',
	SHUDUSHTE: 'shudushte',
	SHEWATE: 'shewate'
};